import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,  
  Label,
  Header
} from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { userActions } from '../../actions/user.actions';
import { userConstants } from '../../constants/user.constants';

class ImportScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: null,
      file: null,
      errors: {},
      submitted: false,
      modalOpen: false
    };    
  }

  static get propTypes() { 
    return {       
        users: PropTypes.any,
        loading: PropTypes.bool
    }; 
  }

  onChange(e) {          
    this.setState({file:e.target.files[0]});
  }

  handleSubmit() {
    const { dispatch } = this.props;
    const { file } = this.state;
    dispatch(userActions.importUsers(file));
  }

  handleSubmitBlock() {
    const { dispatch } = this.props;
    const { file } = this.state;
    dispatch(userActions.importBlock(file));
  }

  handleSubmitExternalId() {
    const { dispatch } = this.props;
    const { file } = this.state;
    dispatch(userActions.importExternalId(file));
  }

  handleSubmitGroup() {
    const { dispatch } = this.props;
    const { file } = this.state;
    dispatch(userActions.importGroup(file));
  }

  render() {    
    const { errors } = this.state;    
    const { me } = this.props;
      
    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    return <Fragment>
              <Header as='h2'>Importação Usuários</Header>
              <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
                <Form.Field required>                    
                    <Form.Input width={12} required error={errors.file} label='Arquivo' onChange={(e) => this.onChange(e)} name='file' type='file' placeholder='' />
                    { errors.file && <Label color='red'>{errors.file}</Label>}                    
                </Form.Field>       

                <Button primary type='submit' icon='save' content='Importar' />
                <Button 
                  secondary 
                  type='button' 
                  icon='download' 
                  content='Arquivo Modelo' 
                  onClick={() => window.location.href='/docs/modelo-importacao-usuarios.xlsx'} />
              </Form>

              <Header as='h2'>Importação Bloqueio</Header>
              <Form loading={this.props.loading} onSubmit={() => this.handleSubmitBlock()}>
                <Form.Field required>                    
                    <Form.Input width={12} required error={errors.file} label='Arquivo' onChange={(e) => this.onChange(e)} name='file' type='file' placeholder='' />
                    { errors.file && <Label color='red'>{errors.file}</Label>}
                </Form.Field>       

                <Button primary type='submit'>Importar</Button>                
              </Form>

              <Header as='h2'>Importação ID Externo</Header>
              <Form loading={this.props.loading} onSubmit={() => this.handleSubmitExternalId()}>
                <Form.Field required>                    
                    <Form.Input width={12} required error={errors.file} label='Arquivo' onChange={(e) => this.onChange(e)} name='file' type='file' placeholder='' />
                    { errors.file && <Label color='red'>{errors.file}</Label>}
                </Form.Field>       

                <Button primary type='submit'>Importar</Button>                
              </Form>

              <Header as='h2'>Importação Grupos</Header>              
              <Form loading={this.props.loading} onSubmit={() => this.handleSubmitGroup()}>
                <Form.Field required>                    
                    <Form.Input width={12} required error={errors.file} label='Arquivo' onChange={(e) => this.onChange(e)} name='file' type='file' placeholder='' />
                    { errors.file && <Label color='red'>{errors.file}</Label>}
                </Form.Field>       

                <Button primary type='submit' icon='save' content='Importar' />
                <Button 
                  secondary 
                  type='button' 
                  icon='download' 
                  content='Arquivo Modelo' 
                  onClick={() => window.location.href='/docs/modelo-importacao-grupos.xlsx'} />         
              </Form>
           </Fragment>
  }
}

function mapStateToProps(state) {
    const { users } = state;
    return { users, me: users.me || null, }
}

const connectedImportScreen = connect(mapStateToProps)(ImportScreen);
export { connectedImportScreen as ImportScreen };
